module.exports = __webpack_public_path__ + "static/media/Crater17-Chuvilin.fe394949.jpg";